module.exports = __webpack_public_path__ + "static/media/idle.7b98f161.fbx";